// extracted by mini-css-extract-plugin
export var billingAddress = "_xw-g";
export var contactInfo = "_xw-d";
export var customerInfoContainer = "_xw-c";
export var customerInfoContainerMobile = "_xw-h";
export var customerInfoRow = "_xw-a";
export var customerInfoSection = "_xw-b";
export var fullWidthDividerMobile = "_xw-i";
export var imageContainer = "_xw-1";
export var paymentMethod = "_xw-e";
export var priceText = "_xw-6";
export var priceTextMobile = "_xw-7";
export var product = "_xw-0";
export var productImage = "_xw-2";
export var productInfo = "_xw-4";
export var productMobile = "_xw-9";
export var productTitle = "_xw-8";
export var quantityBadge = "_xw-3";
export var quantityText = "_xw-5";
export var shippingAddress = "_xw-f";